import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import Input from './common/Input';
import { validateContactForm } from '../utils/validators';
import { sendContactForm } from '../utils/api';

const ContactForm = () => {
  const { t } = useTranslation();
  const { selectedCategory } = useContext(PagePropsContext);

  const formFields = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    message: '',
    privacy: false
  };

  const [invalidFieldList, setInvalidFieldList] = useState({});
  const [formData, setFormData] = useState(formFields);

  const handleChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value
    }));
  };

  const handleBlur = (field) => {
    const { invalidFields } = validateContactForm(t, formData);
    if (Object.keys(invalidFields).find(property => property === field)) {
      setInvalidFieldList((prevInvalidFieldList) => ({
        ...prevInvalidFieldList,
        [field]: invalidFields[field]
      }));
    }
    else {
      const { [field]: value, ...rest } = invalidFieldList;
      setInvalidFieldList(rest);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { isValid, invalidFields } = validateContactForm(t, formData);
    if (!isValid) {
      setInvalidFieldList(invalidFields);
      return;
    }

    if (sendContactForm({
      ...formData,
      category: selectedCategory ? selectedCategory.id : null
    })) {
      setFormData(formFields);
    }
  }

  return <form className='contact-form' onSubmit={handleSubmit}>
    <p className='contact-form__title'>{t('help.subtitle')}</p>
    <Input
      type='text'
      name='name'
      label={t('contact.name.label')}
      placeholder={t('contact.name.label')}
      value={formData.name}
      invalid={invalidFieldList.name}
      onChange={handleChange}
      onBlur={handleBlur}
      required
    />
    <Input
      type='text'
      name='surname'
      label={t('contact.surname.label')}
      placeholder={t('contact.surname.label')}
      value={formData.surname}
      invalid={invalidFieldList.surname}
      onChange={handleChange}
      onBlur={handleBlur}
      required
    />
    <Input
      type='email'
      name='email'
      label={t('contact.email.label')}
      placeholder={t('contact.email.label')}
      value={formData.email}
      invalid={invalidFieldList.email}
      onChange={handleChange}
      onBlur={handleBlur}
      required
    />
    <Input
      type='tel'
      name='phone'
      label={t('contact.phone.label')}
      placeholder={t('contact.phone.label')}
      value={formData.phone}
      invalid={invalidFieldList.phone}
      onChange={handleChange}
      onBlur={handleBlur}
      required
    />
    <Input
      type='textarea'
      name='message'
      label={t('contact.message.label')}
      placeholder={t('contact.message.label')}
      value={formData.message}
      invalid={invalidFieldList.message}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <Input
      type='checkbox'
      name='privacy'
      label={t('contact.privacy.label')}
      value={formData.privacy}
      invalid={invalidFieldList.privacy}
      onChange={handleChange}
      required
    />
    <button type='submit' className='button button--primary-rounded'>
      {t('contact.send')}
    </button>
  </form>;
}

export default ContactForm;
